'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var GridToolbarConfigurationEventsController = function GridToolbarConfigurationEventsController($scope, $log) {
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateButtonShown = false;
  $scope.selectedRows = [];
  function isRowEmpty(row) {
    return _.isEmpty(row.eventName) && _.isEmpty(row.eventType);
  }
  function setStructureWithOldValues(loadedData, rowid) {
    loadedData[rowid]._old = {};
    var columns = $scope.jqxGridSettings.columns;
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  function getNewEventId(loadedData) {
    return _.chain(loadedData).map('eventId').map(_.toInteger).max() + 1;
  }
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDeleteButtonShown = selectedRows.length > 0 && _.every(selectedRows, isRowEmpty);
    $scope.isDuplicateButtonShown = selectedRows.length === 1 && !isRowEmpty(selectedRows[0]);
    $scope.selectedRows = selectedRows;
  };
  $scope.addEvent = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({
      isNewlyAdded: true,
      eventId: getNewEventId(loadedData)
    });
    setStructureWithOldValues(loadedData, 0);
    $scope.updateData(loadedData);
  };
  $scope.removeEvents = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    _.each($scope.selectedRows, function (selected) {
      loadedData.splice(_.findKey(loadedData, selected), 1);
    });
    $scope.updateData(loadedData);
  };
  $scope.duplicateEntity = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndex = $scope.jqxGridSettings.jqxGrid('getselectedrowindex');
    var rowid = $scope.jqxGridSettings.jqxGrid('getrowid', selectedIndex);
    var oldRow = loadedData[rowid];
    var newRow = _.clone(oldRow);
    newRow.eventId = getNewEventId(loadedData);
    loadedData.splice(rowid, 0, newRow);
    setStructureWithOldValues(loadedData, rowid);
    $scope.updateData(loadedData);
  };
  function hasDuplicates(rows) {
    var valuesChecked = {};
    var value = rows[0].eventName.toLowerCase();
    for (var i = 0; i < rows.length; ++i) {
      value = rows[i].eventName.toLowerCase();
      if (value in valuesChecked) {
        return true;
      }
      valuesChecked[value] = true;
    }
    return false;
  }
  $scope.saveChanges = function () {
    var rows = $scope.jqxGridSettings.jqxGrid('getrows');
    if (_.some(rows, isRowEmpty)) {
      $log.error('GridToolbarConfigurationEventsController: saveChanges - Didn\'t fill all rows');
      toastr.error('Please fill all rows.');
    } else if (hasDuplicates(rows)) {
      $log.error('GridToolbarConfigurationEventsController: saveChanges - Duplicated Records');
      toastr.error('Duplicate record exists');
    } else {
      rows = _.map(rows, function (row) {
        delete row.isNewlyAdded;
        return row;
      });
      $scope.$emit('configuration-events:saveChanges', rows);
    }
  };
  $scope.$on('configuration-events:saveSuccess', function () {
    $scope.clearModifiedCells();
  });
};
GridToolbarConfigurationEventsController.$inject = ['$scope', '$log'];
module.exports = GridToolbarConfigurationEventsController;